export function millisToMinutesAndSeconds(millis) {
    return Math.round(millis / 1000);
}

export const getNumbersFromDateString = (string) => {
    return string.replace(/[^0-9]/g, "");
}

export const getDayMonthYearFromDDMMYYYY = (string) => {
    let day = string.substring(0, 2);
    let month = string.substring(2, 4);
    let year = string.substring(4);

    return [day, month, year]
}

export const addLeadingZero = (num) => {
    return num < 10 ? "0" + num : num.toString();
};
